import * as React from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGlobalUpload } from "@/views/drive/upload/globalUploadContext";
import { type UploadDestination } from "@/views/drive/upload/uploadCoordinator";

interface Props {
  destination: UploadDestination;
  isReadOnly?: boolean;
}

export const UploadModal: React.FC<Props> = ({ destination, isReadOnly }) => {
  const { openUploadDialog } = useGlobalUpload();

  return (
    <Button
      variant="default"
      disabled={isReadOnly || !destination.canUpload}
      onClick={() => openUploadDialog(destination)}
    >
      <Upload className="mr-2 h-5 w-5" />
      Upload
    </Button>
  );
};
